let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1jsQH"), load("bv8GZ"), load("i5eMd"), load("i9sd0"), load("gyXEE"), load("hoPZ9")]).then(() => parcelRequire('fV6QY'));